import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Health check: GET /health é respondido com 200 pelo fallback de SPA do `serve -s`
// (qualquer rota sem arquivo estático correspondente devolve index.html) — ver .healthcheck

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


